import React from "react";
import { Phone, MapPin, Heart } from "lucide-react";
import { SITE } from "@/lib/site-data";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-14 grid md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <Logo className="h-12 w-auto" variant="white" />
          <p className="mt-5 text-sm text-stone-400 max-w-md">
            Há mais de 20 anos cuidando da sua coluna e da sua qualidade de vida — com técnica, escuta e acolhimento.
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="px-3 py-1.5 rounded-full bg-stone-800 text-xs">Acolhedor para todos</span>
            <span className="px-3 py-1.5 rounded-full bg-stone-800 text-xs">Apoia Empreendedoras</span>
          </div>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Navegar</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#sobre" className="hover:text-orange-400">Sobre</a></li>
            <li><a href="#servicos" className="hover:text-orange-400">Serviços</a></li>
            <li><a href="#videos" className="hover:text-orange-400">Depoimentos</a></li>
            <li><a href="#avaliacoes" className="hover:text-orange-400">Avaliações</a></li>
            <li><a href="#contato" className="hover:text-orange-400">Contato</a></li>
          </ul>
        </div>

        <div>
          <div className="text-white font-semibold mb-4">Contato</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-orange-500 shrink-0" /> {SITE.address.full}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-orange-500" /> {SITE.phone}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-5 flex flex-col sm:flex-row justify-between gap-3 text-xs text-stone-500">
          <div>© {new Date().getFullYear()} Clínica Vida Saudável. Todos os direitos reservados.</div>
          <div className="flex items-center gap-1.5">Feito com <Heart className="w-3.5 h-3.5 text-orange-500 fill-orange-500" /> em Cabo Frio</div>
        </div>
      </div>
    </footer>
  );
}
